export default __webpack_public_path__ + "static/media/kycVerificationhelp@2x.5fb171aa.png";